// PROTOTYPE ONLY (087 Super Match, ticket 10). Lets the redesign be reviewed
// without a live navigator session (which requires going through the full
// chat flow, and can expire) — used only when `?bestMatchPrototype=` is set
// AND there's truly no session, so a real live one is always preferred.
// Category shells only; `populateViewModel` (bestMatchPrototype.data.ts)
// tops each one up with fixture providers.
import type { NavigatorResultsViewModel } from '../navigator-results.types';

export const MOCK_CARE_GUIDE_VIEWMODEL: NavigatorResultsViewModel = {
  planTitle: 'Cognitive Decline',
  careStageLabel: 'Cognitive Decline',
  summaryBullets: ['We shaped this guide around what you shared with us.'],
  careStageResources: [],
  categories: [
    { id: 'mock-aging-life-care-manager', name: 'Aging Life Care Manager', isPrimary: true, providers: [], resources: [] },
    { id: 'mock-home-care-provider', name: 'Home Care Provider (non-medical)', isPrimary: false, providers: [], resources: [] },
    { id: 'mock-dementia-care-navigator', name: 'Dementia Care Navigator', isPrimary: false, providers: [], resources: [] },
    { id: 'mock-elder-law-attorney', name: 'Elder Law Attorney', isPrimary: false, providers: [], resources: [] },
  ],
};
